export const cilSortAscending = ["24 24","<path d='M9.455 5.057l-4.243-4.243-4.243 4.243 1.061 1.061 2.432-2.432v19.574h1.5v-19.574l2.432 2.432 1.061-1.061z'></path><path d='M8.625 7.5h5.625v1.5h-5.625v-1.5z'></path><path d='M8.625 10.875h8.625v1.5h-8.625v-1.5z'></path><path d='M8.625 14.25h11.625v1.5h-11.625v-1.5z'></path><path d='M8.625 17.625h14.625v1.5h-14.625v-1.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-sort-ascending.js
// module id = null
// module chunks = 